import {
  autoPayPaymentFailureKeys,
  forcedBanners,
  persistForcedBanners,
  setActiveByKey,
  setBannerFlagByKey,
} from "./slices/notifications";

export const setupBannerMock = (store: any) => {
  if (process.env.REACT_APP_ENV === "production" || typeof window === "undefined") {
    return;
  }

  const apply = (key: string, value: boolean, fixtureContent?: any) => {
    value ? forcedBanners.add(key) : forcedBanners.delete(key);
    persistForcedBanners();
    if (value) store.dispatch(setBannerFlagByKey({ key, value: false }));
    store.dispatch(
      setActiveByKey({
        key,
        value,
        ...(fixtureContent !== undefined ? { fixtureContent } : {}),
      })
    );
  };

  forcedBanners.forEach((key) => apply(key, true));

  const createBannerControls = (owns: (key: string) => boolean) => {
    const accepted = (keys: string[]) => keys.filter((key) => owns(key));
    return {
      on: (...args: any[]) => {
        const options = args[args.length - 1];
        const hasFixture = options?.fixture !== undefined;
        const keys = hasFixture ? args.slice(0, -1) : args;
        const fixture = options?.fixture;
        const content = fixture && typeof fixture === "object" ? fixture : undefined;
        accepted(keys).forEach((key: string) => apply(key, true, content));
      },
      off: (...keys: string[]) => accepted(keys).forEach((key) => apply(key, false, null)),
      clear: () => accepted([...forcedBanners]).forEach((key) => apply(key, false, null)),
      list: () =>
        store
          .getState()
          .mySlice.filter((banner: any) => owns(banner.key))
          .map((banner: any) => banner.key),
      forced: () => accepted([...forcedBanners]),
      status: () =>
        store
          .getState()
          .mySlice.filter((banner: any) => owns(banner.key) && banner.active && !banner.Bannerflag)
          .map((banner: any) => ({
            key: banner.key,
            priority: banner.priority,
            pages: banner.displaypages,
          }))
          .sort((first: any, second: any) => first.priority - second.priority),
    };
  };

  (window as any).__banner = createBannerControls((key) => !autoPayPaymentFailureKeys.has(key));
  (window as any)._autoPayPaymentFailures = createBannerControls((key) => autoPayPaymentFailureKeys.has(key));
};

// QA console usage:
//   window.__banner.on("SecurityPinBanner", {
//     fixture: { title: "Preview", description: "QA content", severity: "attention" },
//   });
//  window.__banner.on("SecurityPinBanner"); // if no forced content is needed
//   window.__banner.off("SecurityPinBanner");
//   window.__banner.clear();
// Autopay* failure banners use window._autoPayPaymentFailures with the same methods, e.g. window._autoPayPaymentFailures.on("AutopayCardExpired");
// `on`, `off`, `clear`, `list`, `forced`, and `status` are available outside production.
// Forced keys persist for the browser session; fixture content only lives in Redux until reload.
